<template>
  <div class="modal fade" id="newsletter">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">

        <!-- Modal Header -->
        <div class="modal-header align-items-center">
          <div>
            <h4 class="modal-title">Subscribe to Newsletter</h4>
            <p>And get access to our exclusive content and updates!</p>
          </div>
          <button type="button" id="modal-close" class="close" data-dismiss="modal">&times;</button>
        </div>

        <!-- Modal body -->
        <div class="modal-body">
          <img src="@/assets/images/popup-bg.png" class="mb-3" alt="">
          <form @submit.prevent="submitNewsLetter" id="newsletter-form" class="form_wrapper newsletter-form">
            <div class="form-group mb-0">
              <input required v-model="newsletter.email" type="email" class="form-control" id="email"
                placeholder="your Email" name="email">
            </div>
            <div class="form-group mt-2">
              <div class="form-group ">
                <label class="mt-2">I want to subsribe to (select all that applies).</label>
                <div class="custom-control custom-checkbox">
                  <input required v-model="newsletter.subscribe_to" type="checkbox" value="GM_Newsletter"
                    class="custom-control-input" id="GM_Newsletter" name="example1">
                  <label class="custom-control-label" for="GM_Newsletter">GM Newsletter</label>
                </div>
              </div>
            </div>
            <captcha :captcha="captcha"></captcha>
          </form>
        </div>

        <!-- Modal footer -->
        <div class="modal-footer">

          <!-- <button type="submit"  class="btn btn_submit">Subscribe</button> -->
          <button type="submit" form="newsletter-form" :disabled="this.$store.getters.apiStatus === 'loading'" class="btn btn_submit">
            <div v-if="this.$store.getters.apiStatus !== 'loading'">Subscribe</div>
            <div v-else class="loader"><Loader></Loader></div>
          </button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import Captcha from '../components/Captcha.vue'
export default {
  name: 'Newsletter',
  components: {
    Captcha
  },
  data () {
    return {
      captcha: {
        recaptchaVerified: false,
        value: null
      },
      newsletter: {
        email: '',
        subscribe_to: []
      }
    }
  },
  methods: {
    submitNewsLetter () {
      if (!this.captcha.recaptchaVerified) {
        this.$toast.error('Please verify captcha!')
        return
      }
      this.newsletter['g-recaptcha-response'] = this.captcha.value
      this.$store
        .dispatch('submitNewsLetter', this.newsletter)
        .then(() => {
          // eslint-disable-next-line no-undef
          grecaptcha.reset()
          this.captcha.recaptchaVerified = false
          this.captcha.value = null

          this.newsletter.email = ''
          this.newsletter.subscribe_to = []
          delete this.newsletter['g-recaptcha-response']
          this.$toast.success('You have been successfully subscribed.')
          $('#modal-close').click()
        })
        .catch((err) => this.$helper.catchHandler(err))
    }
  }
}

</script>

<style scoped>
  .modal {
    z-index: 99999;
  }

  .newsletter-form .custom-control-label:after,
  .newsletter-form .custom-control-label:before {
    top: 0px;
  }

</style>



// WEBPACK FOOTER //
// src/components/Newsletter.vue